import { Viewer } from '@oneclick/tangerine-viewer';
import React from 'react';
import { useViewerContainer } from './useViewerContainer';

function ViewerContainer(props) {
  const { id, authToken, authUser, defaultConfig, docConfig } = useViewerContainer();

  return (
    docConfig !== undefined && (
      <div className="viewer-v2">
        <Viewer
          authToken={authToken}
          contentGuid={id}
          controllersConfig={{ consumption: false, openFileInCurrentTab: true }}
          courseGuid={null}
          domain={defaultConfig.BASE_URL_}
          lang={'en'}
          user={authUser}
          docConfig={docConfig}
        />
      </div>
    )
  );
}

export default ViewerContainer;
